import { createFileRoute } from "@tanstack/react-router";

import BookingDetails from "@/pages/booking/details";

export const Route = createFileRoute("/booking/$id")({
  component: BookingDetailsPage,
  head: () => ({ meta: [{ title: "Your experience is booked!" }] }),
});

function BookingDetailsPage() {
  const { id } = Route.useParams();
  return <BookingDetails id={id} />;
}
